import React, { useState } from "react";
import { DeleteIcon, EditIcon } from "../../components/Shared/TableActionIcons";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { deleteCenter } from "../../store/slices/CostCenterSlice";
import ConfirmationModal from "../../components/Shared/ConfirmationModal";
import { FiTrash2 } from "react-icons/fi";
import TableLoading from "../../components/Shared/TableLoading";
import CustomTreeTable from "../../components/Shared/CustomTreeTable";
import { useNavigate } from "react-router-dom";

export default function CostCenterTable({ data, loading, onRefresh }) {
  const lang = i18next.language;
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [delLoading, setDelLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [confirmationDialogVisible, setConfirmationDialogVisible] = useState(false);


  const templateBody = (rowData) => {
    return (
      <div className="flex gap-1">
        <EditIcon
          onClick={() => {
            navigate("/manager/costCenter/create", {
              state: { editData: rowData?.data },
            });
          }}
          title={t("edit")}
        />
        <DeleteIcon
          onClick={() => {
            setConfirmationDialogVisible(true);
            setSelectedData(rowData);
          }}
          title={t("delete")}
        />
      </div>
    );
  };

  const columnsData = [
    {
      body: templateBody,
      headerCellClass: "!w-[15%]",
      bodyCellClass: "!w-[15%]",
      header: t("actions"),
    },
    {
      header: t("name"),
      headerCellClass: "!w-[40%]",
      bodyCellClass: "!w-[40%]",
      expander: true,
      body: (rowData) => {
        const name = lang === "ar" ? rowData?.data?.name_ar : rowData?.data?.name_en;
        const code = rowData?.data?.code;
        const displayName = code && name ? `${code} - ${name}` : name || "";
        return (
          <span>
            {displayName}{" "}
          </span>
        );
      },
    },
    {
      header: t("category"),
      headerCellClass: "!w-[15%]",
      bodyCellClass: "!w-[15%]",
      body: (rowData) => {
        const category = rowData?.data?.category;
        return category ? t(category === "parent" ? "Parent" : "Child") : "-";
      },
    },
    {
      header: t("description"),
      headerCellClass: "!w-[15%]",
      bodyCellClass: "!w-[15%]",
      body: (rowData) => rowData?.data?.description || "-",
    },
  ];

  const confirmDeleteHandler = () => {
    try {
      setDelLoading(true);
      if (selectedData) {
        dispatch(deleteCenter({ id: selectedData?.data?.id })).then(() => {
          if (onRefresh) onRefresh();
        });
        setConfirmationDialogVisible(false);
        setSelectedData(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDelLoading(false);
    }
  };

  return (
    <div>
      <CustomTreeTable
        data={data}
        isLoading={loading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        stateKey="cost-center-table"
        stateStorage="local"
        columnResizeMode="expand"
        emptyMessage={
          <div className="text-center w-full py-4 text-gray-500">
            {t("no_results_found")}
          </div>
        }
        pt={{
          wrapper: { className: "overflow-auto" },
          table: { className: "min-w-[50rem]" },
        }}
        filterMode={"lenient"}
      />
      <ConfirmationModal
        visible={confirmationDialogVisible}
        setVisible={setConfirmationDialogVisible}
        header="delete_confirmation"
        message={t("do_you_really_want_to_delete_this_cost_center")}
        acceptLabel="Delete"
        rejectLabel="Cancel"
        onAccept={confirmDeleteHandler}
        onReject={() => setConfirmationDialogVisible(false)}
        Icon={FiTrash2}
      />
    </div>
  );
}
